import React, { useEffect, useState } from "react";
import classes from "./Blogs.module.scss";
import Heading from "../../ui/components/heading/Heading.tsx";
import { Link } from "react-router";
import { baseUrl } from "../../constants/strapi-base-url.constant.ts";
import { fetchLocalizedCollection } from "../../constants/cms-locale.constant.ts";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "react-i18next";

const Blogs = () => {
  const { t, i18n } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [blogPreviews, setBlogPreviews] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getContent = async () => {
    try {
      setLoading(true);
      const blogs = await fetchLocalizedCollection(
        "blogs?populate[blog_preview][populate][0]=image&pagination[pageSize]=100",
        i18n.language,
      );

      setBlogPreviews(
        blogs.map((item) => ({
          id: item.slug ?? item.documentId,
          text: item.blog_preview.text,
          title: item.blog_preview.title,
          image: item.blog_preview.image
            ? `${baseUrl}${item.blog_preview.image.url}`
            : null,
        })),
      );

      setLoading(false);
    } catch (error) {
      console.error("Error fetching content:", error);
    }
  };

  useEffect(() => {
    getContent();
  }, [i18n.language]);

  if (loading)
    return (
      <main id="nav-dark" className={classes["loading-container"]}>
        <ClipLoader size={120} color="#182347" />
      </main>
    );

  return (
    <main>
      <Heading
        startRowText={t('blog.title')}
        middleRowText={t('blog.title2')}
        endRowText={t('blog.title3')}
        message=""
        buttonText={t('blog.buttonText')}
        redirect={true}
      />

      <section className="section--white" id="nav-dark">
        <div className={classes.container}>
          <h2 className={classes.title}>{t('blog.text')}</h2>

          {!blogPreviews.length && (
            <div className={classes.empty}>
              {t('blog.noPosts')}
            </div>
          )}

          {!!blogPreviews.length && (
            <div className={classes["blogs-list"]}>
              {blogPreviews.map((blog) => (
                <Link
                  to={blog.id.toString()}
                  className={classes["blog-link"]}
                  key={blog.id}
                >
                  <div className={classes.blog} key={blog.id}>
                    {blog.image && <img src={blog.image} alt={blog.title} />}
                    <div className={classes["text-container"]}>
                      <h3 className={classes["blog-title"]}>{blog.title}</h3>
                      <p className={classes["blog-text"]}>{blog.text}</p>

                      <span className={classes["created-at"]}>
                        {blog.addedAt}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Blogs;
